"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGU = function FlagGU(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-58.44C-15-44.32-33.14-10.69-33.14,12.18S-15,68.68,11.8,82.8C38.64,68.68,56.74,35.05,56.74,12.18S38.64-44.32,11.8-58.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#3cc8ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.59-12a24.6,24.6,0,0,1,20.16-1.71s-8.11-9-19.35-1.68c3-3.66,7.57-8.21,12.49-9.47,0,0-9.79-3.66-15.71,9.4,1.14-6.59.93-16.95-9.68-23,0,0,5.93,12.73,6.52,23.3a10.74,10.74,0,0,0-2.86-5.74C3.55-26.72-1.33-27.21-1.33-27.21s7.78,8.62,11.6,16.78a15,15,0,0,0-12.33-5.8C-16.7-15.74-19.88-7-19.88-7c6.07-2.56,15.7-3.83,23.17-3.2C-6.35-8.46-9.77,3.55-9.77,3.55-2-6.1,6.41-7.67,9.79-7.9,3.63-2.8,4,6.59,4,6.59c1.43-5.29,7-11.31,9.68-14A31.62,31.62,0,0,1,21.82,9.3s1.6-2.66.86-8.08A16.34,16.34,0,0,0,16.33-9.23C29.18-7.46,37.56,1.86,37.56,1.86,33.36-10.4,22.84-12,17.59-12Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M202.48-107.87v240.1H-178.88v-240.1H202.48M209.54-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.55,29.25,3.93,18.07l53.18-1.18L53.59,31.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff965a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.2,26.3c5.33,20.93,21.3,45.09,43,56.5,21.7-11.41,37.67-35.57,43-56.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-23.51,47.49s15.4-.76,24.66,3A3.08,3.08,0,0,1,1.67,56C-2.84,58.94-9.39,64-9.39,68.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.56,75.74C3,69.85,8.18,65.57,15.33,62.79c9.27-3.6,4.19-9.34-.44-13.09C9.36,45.22,16.51,44,46.52,43.37L31.81,66.32,11.8,82.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,86.79l-1.64-.86c-28-14.73-46.83-50-46.83-73.75s18.81-59,46.83-73.75l1.64-.86,1.65.86c28,14.74,46.82,50,46.82,73.75s-18.82,59-46.82,73.75Zm0-141.21C-13-40.39-29.61-9-29.61,12.18S-13,64.75,11.8,78.78c24.84-14,41.41-45.41,41.41-66.6S36.64-40.39,11.8-54.42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.8,52.49a1.76,1.76,0,0,1-.93-.27,31.73,31.73,0,0,1-15.1-27.39V-7.68a1.76,1.76,0,0,1,1.76-1.77A1.77,1.77,0,0,1,14.3-7.68V24.83a28.29,28.29,0,0,0,13.44,24.4,1.76,1.76,0,0,1-.94,3.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#a54b37"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.4-7.57a3.86,3.86,0,0,1-3.87,3.86A3.86,3.86,0,0,1,8.67-7.57a3.86,3.86,0,0,1,3.86-3.86A3.86,3.86,0,0,1,16.4-7.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#a54b37"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGU;
exports["default"] = _default;